import { RootState } from 'handlers';

export const getYourBirthDateData = ({ yourBirthDate }: RootState) => yourBirthDate;
